import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { scrollToId } from "@/lib/ui";
import { EASE } from "./Reveal";

export function StickyJoinBar() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 1.2);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && !dismissed && (
        <motion.div
          data-testid="sticky-join-bar"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: EASE }}
          className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-ink/90 backdrop-blur-xl"
        >
          <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8">
            <div className="hidden items-center gap-3 sm:flex">
              <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-neon" />
              <span className="font-display text-sm font-bold uppercase tracking-tight text-white">
                P.E.E. OS™
              </span>
              <span className="font-mono text-[9px] uppercase tracking-[0.25em] text-dim">
                Execution Over Everything
              </span>
            </div>
            <div className="flex flex-1 items-center justify-end gap-2 sm:flex-none">
              <button
                data-testid="sticky-join-button"
                onClick={() => scrollToId("pricing")}
                className="flex-1 rounded-md bg-neon px-5 py-2.5 font-display text-xs font-bold uppercase tracking-wider text-ink transition-shadow duration-300 hover:shadow-[0_0_24px_rgba(0,255,102,0.45)] sm:flex-none"
              >
                Join Execution Traders
              </button>
              <button
                data-testid="sticky-join-dismiss"
                onClick={() => setDismissed(true)}
                aria-label="Dismiss"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-line text-dim transition-colors hover:border-mist/50 hover:text-white"
              >
                <X size={14} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
